export class CWTypeScript {

  // ─── KULLANICI ───────────────────────────────────────────────────────────────

  static SetKullanici(kullaniciId: string): void {
    localStorage.setItem("aktif_kullanici", kullaniciId);
  }

  private static getAktifKullanici(): string {
    return localStorage.getItem("aktif_kullanici") || "";
  }

  // ─── BİLDİRİM ───────────────────────────────────────────────────────────────

  private static getSayiKey(kullaniciId: string): string {
    return `bildirim_sayi_${kullaniciId}`;
  }

  static SayiGuncelle(kullaniciId: string, yeniSayi: number): string {
    const eskiSayi = parseInt(localStorage.getItem(this.getSayiKey(kullaniciId)) || '0');
    localStorage.setItem(this.getSayiKey(kullaniciId), yeniSayi.toString());
    return yeniSayi > eskiSayi ? 'YENI_BILDIRIM' : 'DEGISIKLIK_YOK';
  }

  static SayiGetir(kullaniciId: string): number {
    return parseInt(localStorage.getItem(this.getSayiKey(kullaniciId)) || '0');
  }

  static SayiAzalt(kullaniciId: string): number {
    const yeni = Math.max(0, this.SayiGetir(kullaniciId) - 1);
    localStorage.setItem(this.getSayiKey(kullaniciId), yeni.toString());
    return yeni;
  }

  static SayiSifirla(kullaniciId: string): void {
    localStorage.setItem(this.getSayiKey(kullaniciId), '0');
  }

  // ─── KALEM HELPERS ──────────────────────────────────────────────────────────

  private static getKey(kullaniciId: string, projeId: string, tipKodu: string): string {
    return `sepet_${kullaniciId}_${projeId}_${tipKodu}`;
  }

  private static getListe(kullaniciId: string, projeId: string, tipKodu: string): KalemItem[] {
    try {
      const json = localStorage.getItem(this.getKey(kullaniciId, projeId, tipKodu));
      return json ? JSON.parse(json) : [];
    } catch { return []; }
  }

  private static setListe(liste: KalemItem[], kullaniciId: string, projeId: string, tipKodu: string): void {
    localStorage.setItem(this.getKey(kullaniciId, projeId, tipKodu), JSON.stringify(liste));
  }

  private static genelToplamHesapla(liste: KalemItem[]): KalemItem[] {
    const toplam = liste.reduce((sum, k) => sum + k.satırToplam, 0);
    liste.forEach(k => k.genelToplam = toplam);
    return liste;
  }

  // ─── DOSYA HELPERS ──────────────────────────────────────────────────────────

  private static getDosyaKey(kullaniciId: string, projeId: string, tipKodu: string): string {
    return `dosyalar_${kullaniciId}_${projeId}_${tipKodu}`;
  }

  private static getDosyaListe(kullaniciId: string, projeId: string, tipKodu: string): DosyaItem[] {
    try {
      const json = localStorage.getItem(this.getDosyaKey(kullaniciId, projeId, tipKodu));
      return json ? JSON.parse(json) : [];
    } catch { return []; }
  }

  private static setDosyaListe(liste: DosyaItem[], kullaniciId: string, projeId: string, tipKodu: string): void {
    localStorage.setItem(this.getDosyaKey(kullaniciId, projeId, tipKodu), JSON.stringify(liste));
  }

  // ─── SAYFA ──────────────────────────────────────────────────────────────────

  static SayfaAcildi(kullaniciId: string, projeId: string, tipKodu: string): void {
    this.SetKullanici(kullaniciId);
    localStorage.removeItem(this.getKey(kullaniciId, projeId, tipKodu));
    localStorage.removeItem(this.getDosyaKey(kullaniciId, projeId, tipKodu));
  }

  // ─── KALEM METODLARI ────────────────────────────────────────────────────────

  static KalemleriDBdenYukle(
    kullaniciId: string,
    projeId: string,
    tipKodu: string,
    dbSonucu: DBKalemItem[]
  ): KalemItem[] {
    try {
      const liste: KalemItem[] = dbSonucu.map((d: DBKalemItem) => ({
        stokKodu: d.stokKodu,
        stokAdi: d.stokAdi,
        birim: d.birim ?? '',
        birimFiyat: d.birimFiyat ?? 0,
        miktar: d.miktar ?? 0,
        satırToplam: (d.birimFiyat ?? 0) * (d.miktar ?? 0),
        genelToplam: 0,
        sonuc: 'DB'
      }));
      this.genelToplamHesapla(liste);
      this.setListe(liste, kullaniciId, projeId, tipKodu);
      return liste;
    } catch { return []; }
  }

  static KalemEkle(
    kullaniciId: string,
    projeId: string,
    tipKodu: string,
    stokKodu: string,
    stokAdi: string,
    birim: string,
    birimFiyat: number,
    miktar: number
  ): KalemItem[] {
    this.SetKullanici(kullaniciId);
    const liste = this.getListe(kullaniciId, projeId, tipKodu);
    const mevcut = liste.find(k => k.stokKodu === stokKodu);
    if (mevcut) {
      mevcut.miktar += miktar;
      mevcut.satırToplam = mevcut.miktar * mevcut.birimFiyat;
      mevcut.sonuc = 'KALEM MEVCUT';
    } else {
      liste.push({
        stokKodu, stokAdi, birim, birimFiyat, miktar,
        satırToplam: birimFiyat * miktar, genelToplam: 0, sonuc: 'OK'
      });
    }
    this.genelToplamHesapla(liste);
    this.setListe(liste, kullaniciId, projeId, tipKodu);
    return liste;
  }

  static KalemSil(
    kullaniciId: string,
    projeId: string,
    tipKodu: string,
    stokKodu: string
  ): KalemItem[] {
    const liste = this.getListe(kullaniciId, projeId, tipKodu).filter(k => k.stokKodu !== stokKodu);
    this.genelToplamHesapla(liste);
    this.setListe(liste, kullaniciId, projeId, tipKodu);
    return liste;
  }

  static KalemGuncelle(
    kullaniciId: string,
    projeId: string,
    tipKodu: string,
    stokKodu: string,
    birimFiyat: number,
    miktar: number
  ): KalemItem[] {
    const liste = this.getListe(kullaniciId, projeId, tipKodu);
    const kalem = liste.find(k => k.stokKodu === stokKodu);
    if (kalem) {
      kalem.birimFiyat = birimFiyat;
      kalem.miktar = miktar;
      kalem.satırToplam = birimFiyat * miktar;
    }
    this.genelToplamHesapla(liste);
    this.setListe(liste, kullaniciId, projeId, tipKodu);
    return liste;
  }

  static KalemleriGetir(kullaniciId: string, projeId: string, tipKodu: string): KalemItem[] {
    return this.genelToplamHesapla(this.getListe(kullaniciId, projeId, tipKodu));
  }

  static GenelToplam(kullaniciId: string, projeId: string, tipKodu: string): number {
    return this.getListe(kullaniciId, projeId, tipKodu)
      .reduce((sum, k) => sum + k.satırToplam, 0);
  }

  static KaydetHazirla(kullaniciId: string, projeId: string, tipKodu: string): string {
    const liste = this.getListe(kullaniciId, projeId, tipKodu);
    localStorage.removeItem(this.getKey(kullaniciId, projeId, tipKodu));
    return JSON.stringify(liste);
  }

  // ─── DOSYA METODLARI ────────────────────────────────────────────────────────

  static DosyalariDBdenYukle(
    kullaniciId: string,
    projeId: string,
    tipKodu: string,
    dbSonucu: DBDosyaItem[]
  ): DosyaItem[] {
    try {
      const liste: DosyaItem[] = dbSonucu.map((d: DBDosyaItem) => ({
        dosyaAdi: d.dosyaAdi,
        base64Icerik: d.base64Icerik ?? '',
        dosyaTipi: d.dosyaTipi ?? '',
        dosyaBoyutu: d.dosyaBoyutu ?? 0,
        yuklemeTarihi: d.createdAt ?? ''
      }));
      this.setDosyaListe(liste, kullaniciId, projeId, tipKodu);
      return liste;
    } catch { return []; }
  }

  static DosyaEkle(
    kullaniciId: string,
    projeId: string,
    tipKodu: string,
    dosyaAdi: string,
    base64Icerik: string,
    dosyaTipi: string,
    dosyaBoyutu: number
  ): DosyaItem[] {
    this.SetKullanici(kullaniciId);
    const liste = this.getDosyaListe(kullaniciId, projeId, tipKodu);
    const mevcutIndex = liste.findIndex(d => d.dosyaAdi === dosyaAdi);
    const dosya: DosyaItem = {
      dosyaAdi, base64Icerik, dosyaTipi, dosyaBoyutu,
      yuklemeTarihi: new Date().toISOString()
    };
    if (mevcutIndex >= 0) { liste[mevcutIndex] = dosya; }
    else { liste.push(dosya); }
    this.setDosyaListe(liste, kullaniciId, projeId, tipKodu);
    return liste;
  }

  static DosyaSil(
    kullaniciId: string,
    projeId: string,
    tipKodu: string,
    dosyaAdi: string
  ): DosyaItem[] {
    const liste = this.getDosyaListe(kullaniciId, projeId, tipKodu)
      .filter(d => d.dosyaAdi !== dosyaAdi);
    this.setDosyaListe(liste, kullaniciId, projeId, tipKodu);
    return liste;
  }

  static DosyalariGetir(kullaniciId: string, projeId: string, tipKodu: string): DosyaItem[] {
    return this.getDosyaListe(kullaniciId, projeId, tipKodu);
  }

  static DosyalariKaydetHazirla(kullaniciId: string, projeId: string, tipKodu: string): string {
    const liste = this.getDosyaListe(kullaniciId, projeId, tipKodu);
    localStorage.removeItem(this.getDosyaKey(kullaniciId, projeId, tipKodu));
    return JSON.stringify(liste);
  }

  static DosyaIndir(dosyaAdi: string, base64Icerik: string, dosyaTipi: string): void {
    const byteChars = atob(base64Icerik);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const blob = new Blob([new Uint8Array(byteNumbers)], { type: dosyaTipi || 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = dosyaAdi;
    link.click();
    URL.revokeObjectURL(url);
  }
}

// ─── INTERFACE'LER ───────────────────────────────────────────────────────────

interface KalemItem {
  stokKodu: string;
  stokAdi: string;
  birim: string;
  birimFiyat: number;
  miktar: number;
  satırToplam: number;
  genelToplam: number;
  sonuc: string;
}

interface DosyaItem {
  dosyaAdi: string;
  base64Icerik: string;
  dosyaTipi: string;
  dosyaBoyutu: number;
  yuklemeTarihi: string;
}

interface DBKalemItem {
  stokKodu: string;
  stokAdi: string;
  birim: string;
  birimFiyat: number;
  miktar: number;
  sira: number;
}

interface DBDosyaItem {
  dosyaAdi: string;
  base64Icerik: string;
  dosyaTipi: string;
  dosyaBoyutu: number;
  createdAt: string;
}